import React from "react";
import { NavBarOption } from "../NavBarOption";
import GridOnIcon from '@mui/icons-material/GridOn';
import BiotechIcon from '@mui/icons-material/Biotech';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

interface NavBarType {
    specimenLumiReception: NavBarOption,
    specimenComprehensivewellnessReception: NavBarOption,
    specimenLumiWellnessReception: NavBarOption,
    batches: NavBarOption,
    testing: NavBarOption
}

export const NavBarOptions: NavBarType = {

    specimenLumiReception: {
        name: "Specimen reception",
        redirect: "/carrierscreeningspecimenreception",
        icon: <QrCodeScannerIcon />
    },
    specimenComprehensivewellnessReception: {
        name: "Specimen reception",
        redirect: "/comprehensivewellnessspecimenreception",
        icon: <QrCodeScannerIcon />
    },
    specimenLumiWellnessReception: {
        name: "Specimen reception",
        redirect: "/lumiwellnessspecimenreception",
        icon: <QrCodeScannerIcon />
    },
    batches: {
        name: "Batches",
        redirect: "/batches",
        icon: <GridOnIcon />
    },
    testing: {
        name: "Testing",
        redirect: "/testing",
        icon: <BiotechIcon />
    }

};